//@ts-check
import ACTIONS from '../../../store/actions';
import getDotProp from '../../../utils/getDotProp';
import { gridDataSelector } from '../../selectors/grid';

var runCallback = function runCallback(callback, e, newSelection, store, id) {
  if (callback) {
    var gridData = gridDataSelector(store, {
      id: id
    });
    callback(e, newSelection.map(function (itemId) {
      return gridData[itemId];
    }), newSelection);
  }
};

export var selectItem = function selectItem(selectionType, e, props, item, callback) {
  return function (dispatch, getState) {
    var id = props.id;
    var store = getState();
    var selection = store.grid.selection[id];
    var view = store.grid.views[id];
    var multipleItems = Array.isArray(item);
    var itemId = multipleItems ? null : item ? getDotProp(item, view.idKeyProp) : null;
    var newSelection = selection || [];

    if (selectionType === 'click') {
      var itemSelectedBefore = newSelection.indexOf(itemId) > -1;

      if (itemSelectedBefore) {
        //deselect
        newSelection = selection.filter(function (i) {
          return i !== itemId;
        });
      } else {
        var isMulti = props.multiSelection;

        if (isMulti && e.ctrlKey) {
          newSelection = newSelection.concat(itemId);
        } else if (isMulti && e.shiftKey) {//TODO: consult the view for the items order and select the whole range
        } else {
          newSelection = [itemId];
        }
      }
    } else if (selectionType === 'doubleClick') {
      newSelection = [itemId];
    } else if (selectionType === 'clear') {
      newSelection = [];
    } else if (selectionType === 'set') {
      newSelection = item;
    } else if (selectionType === 'defaultSelection') {
      if (multipleItems) newSelection = item;
    }

    if (props.blockEmptyUnselect && newSelection.length === 0) {
      //restore previous selection
      newSelection = selection || [];
      e.selectionBlocked = true;
    }

    e.selectionType = selectionType;
    runCallback(callback, e, newSelection, store, id);
    return dispatch({
      type: ACTIONS.GRID_SELECTION_SET,
      payload: {
        id: id,
        selection: newSelection
      }
    });
  };
};
export var spatialSelectItem = function spatialSelectItem(e, props, callback) {
  return function (dispatch) {
    var id = props.id;
    return dispatch({
      type: ACTIONS.GRID_SELECTION_SPATIAL,
      payload: {
        id: id,
        e: e,
        props: props,
        callback: callback
      }
    });
  };
};
export default selectItem;